import { render, staticRenderFns } from "./FieldServices.vue?vue&type=template&id=2503a948&scoped=true"
import script from "./FieldServices.vue?vue&type=script&lang=js"
export * from "./FieldServices.vue?vue&type=script&lang=js"
import style0 from "./FieldServices.vue?vue&type=style&index=0&id=2503a948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503a948",
  null
  
)

export default component.exports